var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Messages } from 'primereact/messages';
import * as React from "react";
import { connect } from "react-redux";
import * as OptionTypeFactory from "../../classes/definitions/optionType/optionType";
import ApiRequests from "../../classes/http/ApiRequests";
import HttpRequests from "../../classes/http/HttpRequests";
import OptionTypesList from '../../components/OptionTypes/OptionTypesList/OptionTypesList';
import AppRoutes from '../../config/appRoutes';
import DashboardsReduxProps from "./OptionTypesReduxProps";
var OptionTypes = /** @class */ (function (_super) {
    __extends(OptionTypes, _super);
    function OptionTypes() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.messages = null;
        _this.state = {
            data: []
        };
        _this.getAllOptionTypes = function () {
            _this.api.getOptionTypes()
                .then(function (response) {
                var methods = OptionTypeFactory.createOptionTypes(response.data);
                _this.setState({ data: methods });
            })
                .catch(function (error) {
                _this.http.handleError(error, _this.messages, 'Не можахме да заредим Option Types.', _this.props.history);
            });
        };
        _this.toNewOptionType = function () {
            _this.props.history.push(AppRoutes.optionType.path);
        };
        return _this;
    }
    OptionTypes.prototype.componentDidMount = function () {
        this.getAllOptionTypes();
    };
    OptionTypes.prototype.render = function () {
        var _this = this;
        var data = this.state.data;
        return (React.createElement("div", { className: "container-fluid" },
            React.createElement("div", { className: "animated fadeIn" },
                React.createElement("h1", { className: "display-3" }, "Option Types"),
                React.createElement("hr", null),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement("div", { className: "list-actions" },
                            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.toNewOptionType, type: "button" },
                                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                                " \u041D\u043E\u0432 Option Type")),
                        React.createElement(Messages, { ref: function (el) { _this.messages = el; } }),
                        React.createElement(OptionTypesList, { gridData: data }))))));
    };
    return OptionTypes;
}(React.Component));
export default connect(null, DashboardsReduxProps.mapDispatchToProps)(OptionTypes);



//////////////////
// WEBPACK FOOTER
// ./src/views/OptionTypes/OptionTypes.tsx
// module id = 377
// module chunks = 0